import ClientBadge from '@fingerprinting/features/client/common/client-badge'

import { getChildren, getColor } from './utils'

import type { TApplicationSyncStatusType } from '@fingerprinting/types'
import type { IClientBadgeProps } from '@fingerprinting/features/client/common/client-badge'

interface ISyncBadgeProps extends IClientBadgeProps {
  status?: TApplicationSyncStatusType
}

export default function SyncBadge({
  status,
  children,
  color: colorProps,
  ...props
}: ISyncBadgeProps) {
  const color = getColor(status)
  return (
    <ClientBadge color={colorProps ?? color} {...props}>
      {children ?? getChildren(status)}
    </ClientBadge>
  )
}
